import * as React from "react";
import PropTypes from "prop-types";

import MuiIconButton from "@mui/material/IconButton";
import Skeleton from "ui/Skeleton";

function IconButton(props) {
  const { isLoading = false, ...otherProps } = props;

  const renderIconButton = () => (
    <MuiIconButton variant="context-menu" {...otherProps} />
  );

  if (isLoading) {
    return <Skeleton variant="circular">{renderIconButton()}</Skeleton>;
  }

  return renderIconButton();
}

export const IconButtonPropTypes = {
  size: PropTypes.string,
  sx: PropTypes.object,
  isLoading: PropTypes.bool,
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  variant: PropTypes.oneOf(["context-menu", "header", "filled"]),
};

IconButton.propTypes = IconButtonPropTypes;

export default IconButton;
